import { render, staticRenderFns } from "./_base-helpTooltip.vue?vue&type=template&id=021fea1d&scoped=true"
import script from "./_base-helpTooltip.vue?vue&type=script&lang=js"
export * from "./_base-helpTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021fea1d",
  null
  
)

export default component.exports